<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col cols="12" v-if="!!getActiveCompany">
        <PageHeader
          title="Feladataim"
          :special-back-link="true"
          :enable-back-link="true"
          @goBack="returnToTasks"
        />
      </b-col>
    </b-row>
    <b-row class="font-poppins">
      <b-col cols="12">
        <b-card>
          <template v-slot:header>
            <b-container fluid>
              <b-row>
                <b-col cols="12">
                  <div class="d-flex justify-content-between">
                    <div class="vertical-center ml-0 mr-0 width-max-content">
                      <div class="mb-0 custom-card-header-text">
                        {{ $cte("tasks.myTask") }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-container>
          </template>
          
          <TaskView
            :enable-pagination="myTaskOptions.enablePagination"
            :display-prop="myTaskOptions.displayProp"
            :detail-view="myTaskOptions.detailView"
            :display-all="true"
            :back-router-link="myTaskOptions.backRouterLink"
            :apiLoading="taskLoading"
            :tasks="tasks.content"
          />

          <paging 
            :item-per-page="tasks.itemPerPage"
            :total-rows="tasks.totalElements"
            @paging-change="doPage"
            ref="pageing"
          />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client/index";
import { mapGetters } from "vuex";
import TaskView from "../../../components/TaskView";
import Paging from "../../../components/Paging.vue";

export default {
  name: "Tasks",
  components: {
    PageHeader, 
    TaskView,
    Paging
  },
  data() {
    return {
      myTaskOptions: {
        itemPerPage: 5,
        apiCallback: Api.getTasks,
        enablePagination: true,
        detailView: "/app/task",
        displayProp: "title",
        backRouterLink: "/app/tasks",
      },
      apiLoading: true,
      tasks: []
    };
  },
  methods: {
    returnToTasks() {
      let self = this;
      if (self.backRouterLink) {
        if (self.pageNumber) {
          self.$router.push({
            path: self.backRouterLink,
            query: {
              pageNumber: self.pageNumber,
              perPage: self.perPage,
            },
          });
        } else {
          self.$router.push(self.backRouterLink);
        }
      } else {
        self.$router.push("/app/home");
      }
    },

    newTask() {
      window.open("https://www.messenger.com/t/acountoapp", "_blank");
    },

    loadTasks(page, size) {
      this.apiLoading = true;
      Api.getTasksWithPagination(page, size, this.getActiveCompany.id, true)
          .then((resp) => {
            this.tasks = resp.data;
            this.apiLoading = false;
          })
          .catch(() => {
            this.$toast.error({
              title: 'Hiba',
              message: 'Értesítők betöltése sikertelen',
            });
          })
    },
    doPage(data) {
      this.loadTasks(data.pagingPage - 1, data.pagingOffset);
    },
    
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  mounted() {
    this.loadTasks(0,5)
  }
};
</script>

<style scoped></style>
